import Component from '@glimmer/component';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import { dropTask } from 'ember-concurrency';
import { isEmpty } from '@ember/utils';
import arrayToSentence from 'garaje/helpers/array-to-sentence';

/**
 * @param {Object}              location
 * @param {String}              integration
 * @param {Function}            openAction
 * @param {Function}            closeAction
 * @param {Function}            integrationDisconnected
 */
export default class IftttConfigBox extends Component {
  @service currentAdmin;

  get company() {
    return get(this.args.location, 'company.content');
  }

  get iftttIntegration() {
    return get(this.company, 'iftttIntegration.content');
  }

  get connected() {
    return !isEmpty(this.iftttIntegration);
  }

  get isOpen() {
    return this.args.integration === 'ifttt';
  }

  get connectedTo() {
    const emails = this.iftttIntegration.granteeEmails.split(',').map((email) => {
      return `<b>${email}</b>`;
    });

    return htmlSafe(arrayToSentence(emails));
  }

  confirmDisconnect() {
    return window.confirm('Are you sure you want to disconnect this integration?');
  }

  @dropTask
  *disconnectTask() {
    if (!this.confirmDisconnect()) {
      return;
    }

    const iftttIntegration = this.iftttIntegration;
    yield iftttIntegration.destroyRecord();
    this.args.closeAction();
    this.args.integrationDisconnected();
  }
}
